import React from 'react';

export const PainelContexto = React.createContext(null);